import React from 'react';

const PrinterIcon = (props) => (
  <svg width='32px' height='32px' viewBox='0 0 32 32' {...props}>
    <g id='iconography/material-design-icons/printer-32x32' fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 7.000000)'>
        <path d='M16,0 L4,0 L4,4 L16,4 M17,9 C16.4477153,9 16,8.55228475 16,8 C16,7.44771525 16.4477153,7 17,7 C17.5522847,7 18,7.44771525 18,8 C18,8.55228475 17.5522847,9 17,9 M14,16 L6,16 L6,11 L14,11 M17,5 L3,5 C1.34314575,5 -4.4408921e-16,6.34314575 -4.4408921e-16,8 L-4.4408921e-16,14 L4,14 L4,18 L16,18 L16,14 L20,14 L20,8 C20,6.34314575 18.6568542,5 17,5 Z' />
      </g>
    </g>
  </svg>
);

export default PrinterIcon;
